export default __webpack_public_path__ + "static/media/gestionMission.cbf55d09.svg";